import moment from 'moment';

export default class Utils {
  static yesno() {
    return [
      { id: 1, nm: 'Yes' },
      { id: 0, nm: 'No' }
    ];
  }
  static role() {
    return [
      { id: 1, nm: 'User' },
      { id: 3, nm: 'Admin' }
    ];
  }
  static ioid(flg: string) {
    return flg === '-' ? 1 : 2;
  }
  static drcrid(tmpid: number) {
    return tmpid === 1 ? 'Dr' : 'Cr';
  }
  static drcr() {
    return [
      { id: 1, nm: 'Dr' },
      { id: 2, nm: 'Cr' }
    ];
  }
  static vstatus() {
    return [
      { id: 0, nm: 'Open' },
      { id: 1, nm: 'Approved' },
      { id: 2, nm: 'Dispach' }
    ];
  }
  static voucherlist() {
    return [
      { id: 1, nm: 'Receipt' },
      { id: 2, nm: 'Payment' },
      { id: 3, nm: 'Journal' }
    ];
  }
  static bptlist() {
    return [
      { id: 1, nm: 'Balance sheet' },
      { id: 2, nm: 'Profit & Loss' },
      { id: 3, nm: 'Trading' }
    ];
  }
  static freightterms() {
    return [
      { id: 1, nm: 'FOR(Prepaid)' },
      { id: 2, nm: 'Ex-Factory(To Pay)' }
    ];
  }
  static getLocalStorageObject(key: string): any {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : {};
  }
  static setLocalStorageObject(key: string, obj: any): void {
    localStorage.setItem(key, JSON.stringify(obj));
  }

  static dmy(date: any) {
    return moment(date).format('DD-MM-YYYY');
  }
  static dateperiod(fdt: any, tdt: any) {
    return this.dmy(fdt) + ' to ' + this.dmy(tdt);
  }

  static setcalval(val: any) {
    val = Number(val.toFixed(2));
    if (val % 1 == 0) {
      val = val.toFixed(0);
    }
    return Number(val);
  }
  static setbtoz(val: any) {
    if (isNaN(Number(val))) {
      return 0;
    } else {
      return Number(val);
    }
  }
}
